import { render, staticRenderFns } from "./AssignAgentAdmin.vue?vue&type=template&id=012e491d&scoped=true&"
import script from "./AssignAgentAdmin.vue?vue&type=script&lang=js&"
export * from "./AssignAgentAdmin.vue?vue&type=script&lang=js&"
import style0 from "./AssignAgentAdmin.vue?vue&type=style&index=0&id=012e491d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012e491d",
  null
  
)

export default component.exports